export interface Config {
  apiUrl: string;
  isDev: boolean;
}

const config: Config = {
  apiUrl: import.meta.env.VITE_API_URL ?? "http://localhost:3000",
  isDev: import.meta.env.DEV,
};

export default config;
